import { faker } from '@faker-js/faker';
import {
  SiteSubjectType,
  SiteSubjectDetails,
  Visits,
  SubjectStatus,
} from '@dynamika-shared/types/subjects';
import { mockPaginate } from './paginate';

const statuses = ['IN_PROGRESS', 'COMPLETED', 'FAILED', 'CREATED', 'CLOSED'];

export function createRandomSubject(): SiteSubjectType {
  return {
    dob: '11.1994',
    cohortId: 'fe1fe1c5-4ef8-4af8-8045-1b9be7214d1a',
    code: '235',
    id: faker.string.alphanumeric(10),
    lastVisit: {
      type: '',
      id: faker.string.alphanumeric(10),
      latestUpload: faker.string.alphanumeric(10),
      earlyTermination: false,
      name: faker.word.noun(),
    },
  };
}

export function createRandomVisit(): Visits {
  return {
    id: faker.string.uuid(),
    visitName: faker.word.noun(10),
    visitDefinitionId: faker.string.uuid(),
    latestUpload: '2024-10-08T14:32:36.032Z',
    status: faker.helpers.arrayElement(statuses) as SubjectStatus,
    expectedDate: '2024-10-08T14:32:36.032Z',
    type: 'REGULAR',
    earlyTerminated: false,
  };
}

export const createRandomVisits = (count: number): Visits[] => {
  return faker.helpers.multiple(() => createRandomVisit(), {
    count,
  });
};

export function createRandomSiteSubjectDetails(
  visitsQuantity: number
): SiteSubjectDetails {
  return {
    id: faker.string.uuid(),
    dob: '11.1994',
    siteId: faker.string.uuid(),
    cohortId: faker.string.uuid(),
    patientCode: faker.string.alphanumeric({ length: { min: 3, max: 7 } }),
    lastUploadedVisitDefId: faker.string.uuid(),
    lastUploadedVisitName: faker.word.noun(10),
    lastUploadedVisitId: faker.string.uuid(),
    uploadStatus: faker.helpers.arrayElement(statuses) as SubjectStatus,
    visits: createRandomVisits(visitsQuantity),
  };
}

export function createRandomSubjectList(count: number): SiteSubjectType[] {
  return faker.helpers.multiple(createRandomSubject, { count });
}

export function createPaginatedRandomSiteUsersList(
  count: number,
  args = { page: 1, size: 10 }
) {
  const subjectList = createRandomSubjectList(count);
  return mockPaginate(subjectList, args);
}
